import * as Sentry from '@sentry/vue'

import { Router } from 'vue-router'

export default defineNuxtPlugin(nuxtApp => {
  if (process.env.VITE_SENTRY_DSN != null && process.env.VITE_PRODUCTION === 'prod') {
    const router = nuxtApp.$router as Router
    const configSentry = {
      app: nuxtApp.vueApp,
      dsn: process.env.VITE_SENTRY_DSN,
      integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
      tracesSampleRate: 0.4,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      release: process.env.VITE_APP_VERSION
    }

    Sentry.init(configSentry)

    // Captura qualquer erro não tratado
    nuxtApp.vueApp.config.errorHandler = (error, vm, info) => {
      Sentry.captureException(error, {
        extra: {
          info,
          vm
        }
      })
      console.error(error)
    }
  }
})
